module.exports = __webpack_public_path__ + "static/media/boston.fa34fbee.webp";